import React from 'react';

import integerWithThousandSeparator from 'shared-utils/src/integerWithThousandSeparator';

export const depthMap = {
  platinum: {
    name: 'Platinum',
    size: '',
    titleClamp: '',
    descClamp: '',
  },
  'platinum-project': {
    name: 'Platinum',
    size: '',
    titleClamp: '',
    descClamp: '',
  },  
  gold: {
    name: 'Gold',
    size: '',
    titleClamp: '',
    descClamp: '',
  },
  silver: {
    name: 'Silver',
    size: 'medium',
    titleClamp: 'less',
    descClamp: 'medium',
  },
  bronze: {
    name: '',
    size: 'small',
    titleClamp: 'less',
    descClamp: 'less',
  },
  standard: {
    name: '',
    size: 'small',
    titleClamp: 'less',
    descClamp: 'less',
  },
};

export const computeToLoad = (x, loaded = []) => [...new Set([...[x, x + 1, x + 2], ...loaded])];

export const getPrice = ({
  className,
  price,
  projectData,
  isAuction,
  showMortgage,
  showMqPrice,
  mq = null,
  isHoliday,
  includes_property_ownership,
}) => {
  const priceFrom = isAuction ? <>da&nbsp;</> : '';
  let priceValue = '';
  let priceTime = '';
  let priceMq = '';
  let mortgage = '';
  let includesPropertyOwnership = '';

  if (projectData && projectData.price.show) {
    const { value, min, max } = projectData.price;
    if (min !== '0' && max !== '0') {
      priceValue = `${min} - ${max}`;
    } else {
      priceValue = value;
    }
  } else if (price.show) {
    const { value, min, max } = price;
    if (isHoliday && min && max && min !== '0' && max !== '0') {
      priceValue = min !== max
        ? `${min} - ${max}`
        : min;
    } else {
      priceValue = value;
    }
    if (showMqPrice && mq) {
      priceMq = <>&nbsp;(&euro;&nbsp;{integerWithThousandSeparator(Math.floor(parseInt(value.replace(/\./g, ''), 10) / mq))} al m²)</>;
    }    
    if (price.period) {
      priceTime = <>&nbsp;{price.period}</>;
    }
    if (showMortgage && price.mortgage) {
      mortgage = <>&nbsp;(Tua da &euro;{price.mortgage}/mese)</>;
    }
    if (includes_property_ownership) {
      includesPropertyOwnership = <>&nbsp;({includes_property_ownership === 'true' ? 'con' : 'senza'} mura)</>
    }
  } else {
    return <>Trattativa riservata</>;
  }
  return <>{priceFrom}&euro;&nbsp;<span className={className}>{priceValue}</span>{priceMq}{priceTime}{mortgage}{includesPropertyOwnership}</>;
};
